import Query, {
  FailSettings,
  HttpMethod,
  QueryMiddleware,
  ResponseType,
  SerializationStrategy,
} from './Query';

export type { FailSettings, HttpMethod, QueryMiddleware, ResponseType, SerializationStrategy };

export default class QueryBuilder {
  query = new Query();

  method(method: HttpMethod): QueryBuilder {
    this.query.method = method;

    return this;
  }

  base(base: string): QueryBuilder {
    this.query.base = base;

    return this;
  }

  path(path: string): QueryBuilder {
    this.query.path = path;

    return this;
  }

  body(requestBody: Any): QueryBuilder {
    this.query.requestBody = requestBody;

    return this;
  }

  addQueryStringParam(key: string, value: Any): QueryBuilder {
    this.query.addQueryStringParam(key, value);

    return this;
  }

  addHeader(key: string, value: Any): QueryBuilder {
    this.query.addHeader(key, value);

    return this;
  }

  limit(limit: Nullable<number>): QueryBuilder {
    this.query.addQueryStringParam('limit', limit);

    return this;
  }

  securityCheck(securityCheck: string): QueryBuilder {
    this.query.setSecurityCheck(securityCheck);

    return this;
  }

  offset(offset: Nullable<number>): QueryBuilder {
    this.query.addQueryStringParam('offset', offset);

    return this;
  }

  shortResponseData(): QueryBuilder {
    this.query.addQueryStringParam('list', true);

    return this;
  }

  indexResponseData(): QueryBuilder {
    this.query.addQueryStringParam('index', true);

    return this;
  }

  serializer(serializer: SerializationStrategy): QueryBuilder {
    this.query.serializer = serializer;

    return this;
  }

  suppressErrorNotifications(): QueryBuilder {
    this.query.suppressErrorNotifications = true;

    return this;
  }

  useMiddlewareOnRequest(middleware: QueryMiddleware): QueryBuilder {
    this.query.addRequestMiddleware(middleware);

    return this;
  }

  useMiddlewareOnResponse(middleware: QueryMiddleware): QueryBuilder {
    this.query.addResponseMiddleware(middleware);

    return this;
  }

  useRepeatOnFail(failSettings: FailSettings): QueryBuilder {
    this.query.addFailConfiguration(failSettings);

    return this;
  }

  asJSON(): QueryBuilder {
    this.query.responseType = 'json';

    return this;
  }

  asText(): QueryBuilder {
    this.query.responseType = 'text';

    return this;
  }

  asBlob(): QueryBuilder {
    this.query.responseType = 'blob';

    return this;
  }

  asBlobOrJSON(): QueryBuilder {
    this.query.responseType = 'blob-or-json';

    return this;
  }

  abortSignal(abortSignal: AbortSignal): QueryBuilder {
    this.query.abortSignal = abortSignal;

    return this;
  }

  isAnon(): QueryBuilder {
    this.query.isAnonymous = true;

    return this;
  }

  getQuery(): Query {
    return this.query;
  }
}
